import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';

import * as Papi from '@app/papi';
import { User } from 'papi-client-ng2';
import { Router } from '@angular/router';

declare let mLayout: any;
@Component({
	selector: "app-header-nav",
	templateUrl: "./header-nav.component.html",
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class HeaderNavComponent implements OnInit, AfterViewInit {

	constructor(
		public papi: Papi.Service,
		private router: Router,
	) { }

	ngOnInit() {

	}
	ngAfterViewInit() {

		mLayout.initHeader();

	}

	logout() {
		this.papi.logout();
		const rememberMe = localStorage.getItem('rememberMe');
		if (rememberMe !== 'true') {
			localStorage.removeItem('savedEmail');
		}
		localStorage.removeItem('rememberMe');
		sessionStorage.removeItem('rememberMe');
		this.router.navigate(['/snippets/pages/user/login-1']);
	}


}